module.exports = __webpack_public_path__ + "static/img/bg_bmcg@2x.4bee0c45.png";